/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import List from '@material-ui/core/List'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import { BrowserRouter, NavLink, Redirect, Route, Switch, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { getBot } from '../../tabs/home/api/bots'
import { HOME_PATH, QCS_LOGIN_URL } from '../../configs'
import { isQcsHandoffSession } from '../../tabs/authorization/helpers/qcsHandoffSession'
import { hasPermissionForBot, getUserRole, ROLE } from '../../security'
import { findBotById, isQcsBot, isQcsBotPayload, QCS_ALLOWED_TABS, isTabHiddenForQcsManager, isQcsAccountUser, qcsAccountLandingPath, shouldSkipQcsOrganisationsHome } from '../../constants/qcs'
import {
  isProfessionalsNavAllowed,
  isServiceUsersNavAllowed,
} from '../../tabs/home/api/usageLimits'
import { applyBrandTheme } from '../../constants/qcsTheme'
import { mainRoutes } from '../../routes/mainRoutes'
import PermissionDenied from '../404/404'
import Loader from '../../uiKit/loaders/loader'
import WebSockets from '../../contexts/webSockets'
import { clearOldBot } from '../../tabs/home/actions/activeBot'
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary'
import { UserMenu } from '../../tabs/account/components/UserMenu'
import { clearAttributes } from '../../tabs/settings/actions/attributes'
import { clearWidgetSettings } from '../../tabs/widget/actions/botWidget'
import { ArrowLeft } from '../../uiKit/icons/ArrowLeft'
import { initCopilotWidgetScript, removeCopilotWidget } from './copilot/api/copilot'

import { styles } from './styles'
import { isNotError } from '../../tabs/authorization/actions/forbiddenError'
// eslint-disable-next-line max-len
import { FacebookActivePagesProvider } from '../../tabs/settings/components/integrations/facebook/FacebookActivePages/context'
import { InfoIcon } from '../../uiKit/icons/Info'
import { IS_WHITE_LABELED_PLATFORM } from '../../colorConstants'
import TestButtons from './TestButtons/TestButtons'
import QcsSupervisionButton from './QcsSupervisionButton'
import { LogoIcon, HomeIcon } from '../../uiKit/icons/Icons'
import { QcsLogo } from '../../uiKit/icons/QcsLogo'

const QCS_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/images/platform/qcs-logo.svg`

class MainMenu extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
      redirectToBots: false,
      activeBot: null,
      ifCreateSocket: false,
      redirectToAccountSettings: false,
      botLoadFailed: false,
      botAccessDenied: false,
      supervisionCtaVisible: false,
    }
    this.botLoadSeq = 0
  }

  adminHasBotAccess(botId) {
    const accesses = this.props.adminUser && this.props.adminUser.botAccesses
    if (!Array.isArray(accesses)) return true
    return accesses.some(access => Number(access.botId) === Number(botId))
  }

  sessionHomePath() {
    if (isQcsAccountUser(this.props.adminUser)) {
      const landing = qcsAccountLandingPath(this.props.adminUser)
      if (!landing) return `${HOME_PATH}/qcs`
      // One-org skip is QCS-only; a lone CareBrain organisation goes to its list. A bot
      // not loaded yet keeps the landing: that list would skip a QCS bot straight back here.
      const loneBot = findBotById(this.props.adminUser.botAccesses[0].botId)
      return loneBot && !isQcsBotPayload(loneBot) ? HOME_PATH : landing
    }
    return HOME_PATH
  }

  tryLoadActiveBot() {
    const botId = this.props.match.params.botId
    if (!this.props.adminUser) return
    if (!this.adminHasBotAccess(botId)) {
      this.setState({ botAccessDenied: true })
      return
    }
    this.loadActiveBot(botId)
  }

  loadActiveBot(botId) {
    const loadId = ++this.botLoadSeq
    getBot(botId).then(result => {
      if (loadId !== this.botLoadSeq) return
      if (!result && Number(this.props.match.params.botId) === Number(botId)) {
        this.setState({ botLoadFailed: true })
      }
    })
  }

  componentDidMount() {
    applyBrandTheme(isQcsBot(this.props.activeBot || this.props.match.params.botId))
    this.tryLoadActiveBot()
  }

  componentDidUpdate(prevProps) {
    const botChanged = prevProps.match.params.botId !== this.props.match.params.botId
    const adminArrived = !prevProps.adminUser && this.props.adminUser
    const adminChanged =
      (prevProps.adminUser && prevProps.adminUser.id) !== (this.props.adminUser && this.props.adminUser.id)

    if (botChanged || adminArrived || adminChanged) {
      this.setState({ botLoadFailed: false, botAccessDenied: false })
      this.tryLoadActiveBot()
    }
    this.addCopilotWidget()
    if (this.props.activeBot) {
      localStorage.setItem('activeBotName', this.props.activeBot.name)
    }
    applyBrandTheme(isQcsBot(this.props.activeBot || this.props.match.params.botId))
  }

  componentWillUnmount() {
    applyBrandTheme(false)
    clearOldBot()
    clearAttributes()
    clearWidgetSettings()

    this.setState({ copilotWidgetInitialized: false })
    removeCopilotWidget()
  }

  addCopilotWidget() {
    const shouldAddCopilot =
      !this.state.copilotWidgetInitialized &&
      this.props.adminUser &&
      this.props.activeBot &&
      hasPermissionForBot(this.props.activeBot.id, 'copilot')
    if (shouldAddCopilot) {
      initCopilotWidgetScript(this.props.adminUser, this.props.activeBot)
      this.setState({ copilotWidgetInitialized: true })
    }
  }

  redirectToBots() {
    this.setState({ redirectToBots: true }, () => isNotError())
  }

  /** Home means the list this organisation actually appears on. */
  homePath() {
    return isQcsBot(this.props.activeBot || this.props.match.params.botId)
      ? `${HOME_PATH}/qcs`
      : HOME_PATH
  }

  isRouteAllowed(path) {
    const botId = this.props.match.params.botId
    if (!hasPermissionForBot(botId, path)) return false
    if (isQcsBot(this.props.activeBot || botId)) {
      if (!QCS_ALLOWED_TABS.includes(path)) return false
      // QCS Care Managers only see Professionals + Service Users in the rail.
      if (getUserRole(botId) === ROLE.MANAGER && isTabHiddenForQcsManager(path)) {
        return false
      }
      // Package off + never used → hide rail and page (grandfathers *FeatureUsed).
      const bot = this.props.activeBot
      if (path === 'serviceUsers' && bot && !isServiceUsersNavAllowed(bot)) return false
      if (path === 'professionals' && bot && !isProfessionalsNavAllowed(bot)) return false
      return true
    }
    return true
  }

  redirectToAccountSettings = () => {
    this.setState({ redirectToAccountSettings: true })
  }

  handleSupervisionCtaVisibleChange = visible => {
    if (this.state.supervisionCtaVisible !== visible) this.setState({ supervisionCtaVisible: visible })
  }

  // QCS only: deactivated org has nothing to manage until switched back on.
  // CareBrain has no activation toggle — never show this notice there.
  isBotDeactivated() {
    const { activeBot } = this.props
    if (!activeBot || !isQcsBot(activeBot)) return false
    return activeBot.botActivated === false
  }

  renderDeactivatedNotice() {
    const { classes } = this.props
    const botId = this.props.match.params.botId
    const message =
      getUserRole(botId) === ROLE.ADMIN
        ? 'Currently the bot is deactivated'
        : 'Currently the bot is deactivated, please contact admin for support.'
    return (
      <div className={classes.deactivatedWrap}>
        <section className={classes.deactivatedContent}>
          <img className={classes.deactivatedLogo} src={QCS_LOGO_SRC} alt="QCS" width={82} height={82} />
          <p className={classes.deactivatedText}>{message}</p>
        </section>
      </div>
    )
  }

  handleOpenDocumentation() {
    const link = 'https://carebrain.notion.site/Help-Support-1f92e7ff913880ef923fd0240b411cd6?pvs=74'
    window.open(link, '_blank')
  }

  unassignedToAndUnreadCounter(supportRequests, styleClasses) {
    return supportRequests.unassignedCount || supportRequests.unreadAssignedToCount ? (
      <div className={styleClasses}>{supportRequests.unassignedCount + supportRequests.unreadAssignedToCount}</div>
    ) : null
  }

  render() {
    if (this.state.botAccessDenied) {
      return <Redirect to={this.sessionHomePath()} />
    }

    if (this.state.botLoadFailed) {
      return <Redirect to={this.sessionHomePath()} />
    }

    if (this.state.redirectToBots) {
      return <Redirect to={this.homePath()} />
    }

    if (this.state.redirectToAccountSettings) {
      return (
        <Redirect
          to={{
            pathname: '/account-settings',
            state: { from: this.props.location.pathname },
          }}
        />
      )
    }

    const { classes, activeBot, supportRequests } = this.props
    const botId = Number(this.props.match.params.botId)
    const activeBotReady = activeBot && Number(activeBot.id) === botId
    const isQcs = isQcsBot(activeBot)
    // CareCo Admin / Care Manager with a single org skip the list — hide Home.
    // Admin and multi-org accounts keep Home (same rule as shouldSkipQcsOrganisationsHome).
    const showHomeButton = !isQcs || !shouldSkipQcsOrganisationsHome(this.props.adminUser)
    const pathLink = `${HOME_PATH}/bot/${this.props.match.params.botId}/`
    const pathRoute = `${HOME_PATH}/bot/:botId/`
    const isFunnel = window.location.href.match(/analytics\/\d/g)
    const handoffSession = isQcsHandoffSession()
    const showHomeDivider = handoffSession && !isFunnel && showHomeButton
    const showSupervisionCta =
      isQcs && !this.isBotDeactivated() && getUserRole(this.props.match.params.botId) === ROLE.MANAGER
    // TestButtons always renders "Web Application" for non-QCS bots.
    const hasToolbarCta = !isQcs || (showSupervisionCta && this.state.supervisionCtaVisible)

    return (
      <div className={`${classes.root}${isQcs ? ` ${classes.qcsChrome}` : ''}`}>
        {this.props.adminUser && activeBotReady ? (
          <BrowserRouter>
            <WebSockets
              key={this.props.match.params.botId}
              adminUser={this.props.adminUser}
              botId={this.props.match.params.botId}
              publicBotId={activeBot?.publicIdentifier}>
              <FacebookActivePagesProvider>
                <div className={classes.appFrame}>
                  <AppBar position="absolute" className={classes.appBar}>
                    <Toolbar
                      className={`${classes.Toolbar}${this.isBotDeactivated() ? ` ${classes.toolbarNoRail}` : ''}${
                        hasToolbarCta ? ` ${classes.toolbarWithCta}` : ''
                      }`}
                      disableGutters={!this.state.open}>
                      <div className={classes.toolbarStart}>
                        {handoffSession && (
                          <a
                            href={QCS_LOGIN_URL}
                            className={`${classes.backToAnalytics} ${classes.backToQcs}${
                              showHomeDivider ? ` ${classes.backToQcsBeforeDivider}` : ''
                            }`}>
                            Back to home
                          </a>
                        )}
                        {showHomeDivider && <span className={classes.qcsNavDivider} aria-hidden="true" />}
                        {isFunnel ? (
                          <NavLink to={`${HOME_PATH}/bot/${this.props.match.params.botId}/analytics`}>
                            <p className={classes.backToAnalytics}>
                              <ArrowLeft /> Back to Analytics
                            </p>
                          </NavLink>
                        ) : showHomeButton ? (
                          <p
                            onClick={() => this.redirectToBots()}
                            className={
                              isQcs || handoffSession
                                ? `${classes.homeButton} ${classes.homeButtonQcs}`
                                : classes.homeButton
                            }>
                            {(isQcs || handoffSession) && <HomeIcon width={16} height={16} />}
                            Home
                          </p>
                        ) : null}
                      </div>
                      {this.props.activeBot && (
                        <Typography type="title" style={{ fontFamily: 'Lato, sans-serif' }} className={classes.title}>
                          {this.props.activeBot.name}
                        </Typography>
                      )}
                      <div className={classes.toolbarEnd}>
                        <TestButtons classes={classes} />
                        {showSupervisionCta && (
                          <QcsSupervisionButton
                            botId={this.props.match.params.botId}
                            activeBot={this.props.activeBot}
                            classes={classes}
                            onVisibleChange={this.handleSupervisionCtaVisibleChange}
                          />
                        )}
                        <UserMenu
                          redirectToAccountSettings={this.redirectToAccountSettings}
                          botId={this.props.match.params.botId}
                          // Inside a QCS organisation, availability and Account
                          // Settings belong to the CareBrain support-admin
                          // identity — strip the menu down to Log out, same as
                          // the QCS organisations home.
                          minimal={isQcs}
                        />
                      </div>
                    </Toolbar>
                  </AppBar>
                  {this.isBotDeactivated() ? (
                    this.renderDeactivatedNotice()
                  ) : (
                  <React.Fragment>
                  <div className={classes.menuWrap}>
                    <List className={classes.list}>
                      <div className={classes.imageContainer}>
                        {isQcs ? <QcsLogo /> : <LogoIcon />}
                      </div>
                      {mainRoutes.map(
                        route =>
                          this.isRouteAllowed(route.path) && (
                            <div key={route.name}>
                              {route.path === 'broadcast' || route.path === 'widget' ? (
                                <NavLink
                                  key={route.path}
                                  className={classes.alternativeLink}
                                  activeClassName={classes.alternativeActiveLink}
                                  to={`${pathLink}${route.path}`}>
                                  {route.path === 'support' &&
                                    this.unassignedToAndUnreadCounter(supportRequests, classes.supportAmount)}
                                  {route.icon}
                                  <p className={classes.listItem}>{route.name}</p>
                                </NavLink> ) : (
                                <NavLink
                                  key={route.path}
                                  className={classes.link}
                                  activeClassName={classes.activeLink}
                                  to={`${pathLink}${route.path}`}>
                                  {route.path === 'support' &&
                                    this.unassignedToAndUnreadCounter(supportRequests, classes.supportAmount)}
                                  {route.icon}
                                  <p className={classes.listItem}>{route.name}</p>
                                </NavLink>)}
                              </div>
                          ),
                      )}
                    </List>
                    {!isQcs && (
                      <div className={classes.docLink} onClick={this.handleOpenDocumentation}>
                        <InfoIcon color={'var(--color-text-on-primary)'} />
                        <span>Help</span>
                      </div>
                    )}
                  </div>
                  <Divider />
                  <Route render={({ location }) => {
                    const userRole = getUserRole(Number(this.props.match.params.botId))
                    const isCarecoAdminDashboard =
                      location.pathname === `${HOME_PATH}/bot/${this.props.match.params.botId}/dashboard` &&
                      (userRole === ROLE.CARECO_ADMIN || userRole === ROLE.ADMIN)

                    return (
                      <main
                        className={classes.content}
                        style={{ paddingLeft: isCarecoAdminDashboard ? 0 : 40 }}
                      >
                        <ErrorBoundary>
                          <Switch>
                            {mainRoutes.map(
                              ({ path, component: Component }) =>
                                this.isRouteAllowed(path) && (
                                  <Route path={`${pathRoute}${path}`} key={path} render={rest => <Component {...rest} />} />
                                ),
                            )}
                            <Route component={() => <PermissionDenied botId={this.props.match.params.botId} />} />
                          </Switch>
                        </ErrorBoundary>
                      </main>
                    )
                  }} />
                  </React.Fragment>
                  )}
                </div>
              </FacebookActivePagesProvider>
            </WebSockets>
          </BrowserRouter>
        ) : (
          <Loader />
        )}
      </div>
    )
  }
}

MainMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
  activeBot: state.activeBot,
  supportRequests: state.supportRequests,
  adminUser: state.adminUser,
})

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps)(MainMenu)))
